import React from "react";
import { Modal } from "react-bootstrap";

// Onboarding content. Categories mirror the daily rollup datasets the
// analytics MCP server exposes (see sh_analytics_mcp README); the prompts are
// only suggestions - the assistant looks the real data up per question.
export const GUIDE_CATEGORIES = [
  {
    title: "Device fleet",
    description: "How many devices exist, of what type, and how many are corrupted.",
    prompts: [
      "How many devices do we have by device type?",
      "Show corrupted devices over the last 30 days",
    ],
  },
  {
    title: "Homes",
    description: "Home growth and where homes are located.",
    prompts: [
      "How many homes were created each day in the last 14 days?",
      "Which cities have the most homes?",
    ],
  },
  {
    title: "Users",
    description: "User distribution and the most active households.",
    prompts: ["Show users by city", "Which users have the most homes?"],
  },
  {
    title: "OTA health",
    description: "Firmware campaign outcomes.",
    prompts: ["Which hubs failed their latest campaign?"],
  },
  {
    title: "Trends and comparisons",
    description: "Growth over a window, period-over-period change, and unusual days.",
    prompts: [
      "Compare device growth vs home growth over the last 30 days",
      "Compare this week with last week for homes created",
    ],
  },
];

// Shown as one-click starters in the welcome message.
export const STARTER_PROMPTS = [
  "How many devices do we have by device type?",
  "How many homes were created each day in the last 14 days?",
  "Compare device growth vs home growth over the last 30 days",
];

const QuickGuide = ({ show, onHide, onPick, disabled }) => (
  <Modal show={show} onHide={onHide} size="lg" centered scrollable>
    <Modal.Header closeButton>
      <Modal.Title as="h5">What can I ask?</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <ol className="analytics-guide-steps">
        <li>Ask in plain language, one question at a time.</li>
        <li>The answer arrives as a chat message with its chart or table.</li>
        <li>Keep going - follow-ups stay in the same conversation.</li>
      </ol>

      <div className="analytics-guide-grid">
        {GUIDE_CATEGORIES.map((cat) => (
          <section key={cat.title} className="analytics-guide-card">
            <h6>{cat.title}</h6>
            <p className="text-muted small mb-2">{cat.description}</p>
            <div className="d-flex flex-column gap-1">
              {cat.prompts.map((p) => (
                <button
                  key={p}
                  type="button"
                  className="analytics-chip"
                  disabled={disabled}
                  onClick={() => onPick(p)}
                >
                  {p}
                </button>
              ))}
            </div>
          </section>
        ))}
      </div>

      <div className="small text-muted mt-3">
        <strong>Good to know</strong>
        <ul className="mb-0">
          <li>Data comes from nightly rollups, so it is as of the last completed day, not live.</li>
          <li>Totals are never summed across dates; ask for daily change to see growth.</li>
          <li>If a nightly rollup was missed, the answer will say which days are affected.</li>
          <li>Dates are in IST.</li>
        </ul>
      </div>
    </Modal.Body>
  </Modal>
);

export default QuickGuide;
